import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import { compressAndUpload } from "../../Helpers/Utils/photoUpload";
import "./UnifiedFormStyles.css";

function InstalledQRPHDoorSticker({ navigation, primaryDetails, setPrimaryDetails }) {
  const [errors, setErrors] = useState({});
  const [isUploading, setIsUploading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePhotoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      toast.error("Photo exceeds 5MB limit. Please retake the photo.", {
        autoClose: 3000, hideProgressBar: true, theme: "colored"
      });
      e.target.value = '';
      return;
    }

    setIsUploading(true);
    try {
      const uploadResult = await compressAndUpload(file);
      if (!uploadResult.success) {
        toast.error(uploadResult.error || "Upload failed. Please try again.");
        e.target.value = '';
        return;
      }
      setPrimaryDetails(prev => ({
        ...prev,
        qrph_door_sticker_installed_photo_temp_path: uploadResult.temp_path
      }));
    } catch (error) {
      toast.error("Error uploading photo");
    } finally {
      setIsUploading(false);
    }
  };

  const validate = () => {
    const newErrors = {};
    newErrors.qrph_door_sticker_installed_location = !primaryDetails.qrph_door_sticker_installed_location;
    newErrors.qrph_door_sticker_installed_photo = !primaryDetails.qrph_door_sticker_installed_photo_temp_path;
    setErrors(newErrors);

    const hasErrors = Object.values(newErrors).some(Boolean);
    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (validate()) {
      try { localStorage.setItem('qrph-knowledge-origin', 'installed'); } catch (e) {}
      navigation.go('maya-black');
      // navigation.go('qrph-knowledge');
    }
  };

  const handleBack = () => {
   navigation.previous();
  };


  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">INSTALLED QRPH DOOR STICKER DETAILS</h4>
              <p className="form-desc">Please fill in all required details below</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                

                  {/* Installed QRPH door sticker location */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Installed QRPH door sticker location <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {[
                        "glass door - eye level",
                        "glass door- not eye level",
                        "counter",
                        "glass window",
                        "others"
                      ].map((reason, index) => (
                        <div
                          key={`qrph-location-${index}-${reason}`}
                          className={`form-radio-item${primaryDetails.qrph_door_sticker_installed_location === reason ? " selected" : ""}`}
                        >
                          <div className="form-radio-flex">
                            <Form.Check
                              type="radio"
                              name="qrph_door_sticker_installed_location"
                              value={reason}
                              label={reason}
                              checked={primaryDetails.qrph_door_sticker_installed_location === reason}
                              onChange={handleChange}
                              className="form-radio"
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {errors.qrph_door_sticker_installed_location && (
                      <div className="form-error">Required</div>
                    )}
                  </Form.Group>

                  {/* Photo of Installed QRPH Door Sticker */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Photo of Installed QRPH Sticker <span className="form-required">*</span>
                      {primaryDetails.qrph_door_sticker_installed_photo_temp_path && !isUploading && (
                        <span style={{ marginLeft: '10px', color: '#28a745' }}>✅ Uploaded</span>
                      )}
                    </Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={handlePhotoUpload}
                      isInvalid={errors.qrph_door_sticker_installed_photo}
                      disabled={isUploading}
                    />
                    {isUploading && <div style={{ color: '#007bff', fontSize: '13px', marginTop: '6px' }}>⏳ Uploading...</div>}
                    {errors.qrph_door_sticker_installed_photo && (
                      <div className="form-error">Required</div>
                    )}
                  </Form.Group>

                <div className="form-nav-btns">
                  <AppButton
                    onClick={handleBack}
                    variant="back"
                    className="form-btn variant-secondary"
                  >
                    ← Back
                  </AppButton>
                  <AppButton
                    onClick={handleSubmit}
                    variant="next"
                    className="form-btn variant-primary"
                  >
                    Next →
                  </AppButton>
                </div>
              </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default InstalledQRPHDoorSticker;
